import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { selectCountries } from "../store/purchasesSelectors";
import { fetchCountries } from "../store/purchasesThunks";
import { useContent } from "../../../../contexts/contentContext/contentContext";

const useCountries = () => {
  const dispatch = useAppDispatch();
  const { getLanguageCulture } = useContent();
  const countries = useAppSelector(selectCountries);

  const getCountries = useCallback(() => {
    const culture = getLanguageCulture();
    dispatch(fetchCountries({ culture }));
  }, [getLanguageCulture()]);

  return {
    countries,
    fetchCountries: getCountries,
  };
};

export default useCountries;
